var __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

define(['jquery', 'core', 'model/base', 'app-common/component/to-promise', 'app-common/component/api-call'], function($, core, BaseModel, toPromise, apiCall) {
  var ClientModel;
  return ClientModel = (function(_super) {

    __extends(ClientModel, _super);

    function ClientModel() {
      ClientModel.__super__.constructor.apply(this, arguments);
    }

    ClientModel.prototype.pathRoot = core.getConfig().apiPrefix + 'client.json';

    ClientModel.prototype.defaults = function() {
      return {
        id: null,
        firstName: null,
        lastName: null,
        fullName: null,
        subscriptionPlan: 'bk_new_client',
        registrationDate: null,
        phone: null,
        countryCode: 'US',
        email: null,
        active: true,
        company: null,
        companyEmail: null,
        address: {
          shippingAddressId: null
        },
        roles: ['CLIENT'],
        inboxState: 'PROSPECTIVE',
        currencyId: '2',
        billing: {
          billingAccountCode: null
        },
        assignedPersons: {
          accountants: [],
          bookkeepers: [],
          salespersons: []
        },
        notes: null,
        conversionTracked: false
      };
    };

    ClientModel.prototype.activateBilling = function(last4digits, token) {
      var params,
        _this = this;
      params = {
        last4digits: last4digits,
        token: token
      };
      return toPromise(apiCall('billing', "client/" + (this.get('id')), 'PUT', params))["catch"](this.billingErrorHandler).then(function() {
        return toPromise(_this.fetch());
      });
    };

    ClientModel.prototype.reactivateBilling = function(last4digits, token) {
      var params,
        _this = this;
      params = {
        last4digits: last4digits,
        token: token
      };
      return toPromise(apiCall('billing', "client/" + (this.get('id')) + "/subscription/reactivate", 'PUT', params))["catch"](this.billingErrorHandler).then(function() {
        return toPromise(_this.fetch());
      });
    };

    ClientModel.prototype.cancelBilling = function() {
      var _this = this;
      return toPromise(apiCall('billing', "client/" + (this.get('id')) + "/subscription", 'DELETE'))["catch"](this.billingErrorHandler).then(function() {
        return toPromise(_this.fetch());
      });
    };

    ClientModel.prototype.updateCreditCard = function(last4digits, token) {
      var params,
        _this = this;
      params = {
        last4digits: last4digits,
        token: token
      };
      return toPromise(apiCall('billing', "client/" + (this.get('id')) + "/credit-card", 'PUT', params))["catch"](this.billingErrorHandler).then(function() {
        return toPromise(_this.fetch());
      });
    };

    ClientModel.prototype.billingErrorHandler = function(response) {
      var error;
      error = JSON.parse(response.responseText);
      throw error.messages[0].message;
    };

    return ClientModel;

  })(BaseModel);
});
